import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { useTableSearchState } from '@/hooks/useTableSearchState';

type ProjectsSearchContextValue = {
  searchInput: string;
  setSearchInput: (value: string) => void;
  debouncedSearch: string;
  clearSearch: () => void;
};

const ProjectsSearchContext = createContext<ProjectsSearchContextValue | null>(null);

export function ProjectsSearchProvider({ children }: { children: ReactNode }) {
  const { searchInput, setSearchInput, debouncedSearch, clearSearch } = useTableSearchState();

  const value = useMemo(
    () => ({
      searchInput,
      setSearchInput,
      debouncedSearch,
      clearSearch,
    }),
    [searchInput, setSearchInput, debouncedSearch, clearSearch]
  );

  return <ProjectsSearchContext.Provider value={value}>{children}</ProjectsSearchContext.Provider>;
}

export function useProjectsSearch(): ProjectsSearchContextValue {
  const ctx = useContext(ProjectsSearchContext);
  if (!ctx) {
    throw new Error('useProjectsSearch must be used within ProjectsSearchProvider');
  }
  return ctx;
}
